var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterPurifierIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-11.449 -8 1024 1024",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 16,
    d: "M868.551 136s-49.759 310.5-47.759 784.5c0 0-23.76 38.5-95.76 58.5h-444s-58.241-6.5-102.241-58.5c0 0 3.759-318.5-36.241-784.5V79.48c0-26.22 19.281-46.48 42.481-46.48h642c23.2 0 41.519 20.26 41.519 46.48V136zm-690.589-7s52.769 278 47.115 566c0 0 18.846 24 65.961 30h416.5s43.779-4.052 69.729-26c0 0 7.539-354 54.654-570H177.962zm357.589 514c0-6.627-5.373-12-12-12h-36c-6.627 0-12 5.373-12 12v70c0 6.627 5.373 12 12 12h36c6.627 0 12-5.373 12-12v-70zm-12 82h-36v30h36v-30zm-19-94v-27l-83-26m-240 304h-44v42m0-152v42h44m445.391-572h-244l-20 483h284l-20-483z",
    className: "colorStroke000 svgStroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterPurifierIcon);
export default __webpack_public_path__ + "static/media/water-purifier-icon.bb3e2ae3e835ba5a145a5fb0c94b4001.svg";
export { ForwardRef as ReactComponent };